var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['json-compare', { 'm-error': !_vm.valid }]},[_c('div',{staticClass:"json-compare__error"}),_c('input-code-editor',{attrs:{"value":_vm.currentData,"diffValue":_vm.savedData,"autoHeight":_vm.autoHeight,"config":{},"readOnly":""},on:{"input":_vm.dataUpdated}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }